export default __webpack_public_path__ + "static/media/people-ryan-magcity.a436b9a6.jpg";